import React, { useState } from 'react';
import { Container, Row, Col, Button, Card, Badge, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Home = () => {

  const featuredProducts = [
    {
      title: 'Aluminium Melting Furnace',
      image: '/images/ALUMINIUM_MELTING/Al melting furnace.jpg',
      description: 'High-efficiency melting systems with tilting mechanism',
      features: ['Energy Efficient', 'Automated Control', 'Tilting Position']
    },
    {
      title: 'Lead Refining Plant',
      image: '/images/LEAD_REFINING_PLANT/three refining pot furnaces with total capacity of 2000 mt per month - Copy.jpg',
      description: 'Complete refining solutions with 2000 MT/month capacity',
      features: ['2000 MT/Month', 'Complete Plant', 'Quality Control']
    },
    {
      title: 'Air Pollution Control',
      image: '/images/air_pollution/Air pollution control plant dry system.jpg',
      description: 'Advanced pollution control systems for clean operations',
      features: ['Bag House', 'Cyclone System', 'Environmental Compliance']
    }
  ];

  const keyServices = [
    { icon: '🔥', title: 'Thermal System Design', desc: 'Custom engineering solutions' },
    { icon: '⚙️', title: 'Installation & Commissioning', desc: 'Professional setup services' },
    { icon: '🔧', title: 'Maintenance & Support', desc: '24/7 technical support' },
    { icon: '🛡️', title: 'Safety & Compliance', desc: 'International standards' }
  ];

  const achievements = [
    { number: '17+', label: 'Years Experience', icon: '🏆' },
    { number: '500+', label: 'Projects Delivered', icon: '📈' },
    { number: '2000', label: 'MT/Month Capacity', icon: '🏭' },
    { number: '24/7', label: 'Support Available', icon: '🛠️' }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="hero-section" style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #dc2626 100%)'
      }}>
        <Container>
          <Row className="align-items-center" style={{ paddingTop: '30px', paddingBottom: '30px' }}>
            <Col lg={6} className="hero-content">
              <div className="mb-3">
                <Badge bg="light" text="dark" style={{ fontSize: '0.9rem', padding: '8px 16px' }}>
                  🏆 Established 2007 | 17+ Years Excellence
                </Badge>
              </div>
              
              <h1 style={{ 
                fontSize: '3.2rem',
                fontWeight: '700',
                lineHeight: '1.2',
                marginBottom: '1.5rem',
                color: 'white'
              }}>
                Leading Thermal Solutions Provider
              </h1>
              
              <p style={{
                fontSize: '1.2rem',
                lineHeight: '1.6',
                marginBottom: '2rem',
                color: 'rgba(255,255,255,0.9)'
              }}>
                Allied Thermal delivers cutting-edge thermal engineering solutions 
                for industrial and commercial applications. Excellence in innovation, 
                reliability in performance.
              </p>
              
              <div className="mt-4">
                <Button 
                  as={Link} 
                  to="/contact-us" 
                  className="btn-primary-custom me-3"
                  size="lg"
                >
                  Get Free Quote
                </Button>
                <Button 
                  as={Link} 
                  to="/products" 
                  className="btn-outline-custom"
                  size="lg"
                >
                  View Products
                </Button>
              </div>
              
              <div className="mt-4">
                <small style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1rem' }}>
                  📞 +91 9312068097 | 💬 WhatsApp Available | ✉️ alliedthermaldlf@gmail.com
                </small>
              </div>
            </Col>
            
            <Col lg={6} className="text-center">
              <div style={{
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '12px',
                padding: '2rem',
                border: '1px solid rgba(255,255,255,0.2)'
              }}>
                <Carousel indicators={false} controls={true} interval={4000}>
                  {featuredProducts.map((product, index) => (
                    <Carousel.Item key={index}>
                      <img
                        src={product.image}
                        alt={product.title}
                        style={{
                          width: '100%',
                          height: '350px',
                          objectFit: 'cover',
                          borderRadius: '8px'
                        }}
                      />
                      <div className="mt-3">
                        <h5 style={{ color: 'white', fontWeight: '600' }}>{product.title}</h5>
                        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem' }}>
                          {product.description}
                        </p>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Achievements Section */}
      <section className="section-padding company-profile-section">
        <Container>
          <div className="section-title">
            <h2>Our Achievements</h2>
            <p>Trusted by industries across India and internationally</p>
          </div>
          <Row>
            {achievements.map((achievement, index) => (
              <Col lg={3} md={6} className="mb-4" key={index}>
                <div className="stats-card">
                  <span className="stats-number">{achievement.number}</span>
                  <p style={{ fontWeight: '500', color: '#1e293b' }}>
                    {achievement.label}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Featured Products Section */}
      <section className="section-padding">
        <Container>
          <div className="section-title">
            <h2>Featured Products</h2>
            <p>Explore our most popular thermal engineering solutions</p>
          </div>
          <Row>
            {featuredProducts.map((product, index) => (
              <Col lg={4} md={6} className="mb-4" key={index}>
                <Card className="h-100" style={{ 
                  border: 'none',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease'
                }}>
                  <div style={{ height: '250px', overflow: 'hidden' }}>
                    <Card.Img 
                      variant="top" 
                      src={product.image}
                      style={{ 
                        height: '250px',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                    />
                  </div>
                  <Card.Body className="p-4">
                    <Card.Title style={{ fontWeight: '700', color: '#1e293b' }}>
                      {product.title}
                    </Card.Title>
                    <Card.Text style={{ color: '#64748b' }}>
                      {product.description}
                    </Card.Text>
                    <div className="mb-3">
                      {product.features.map((feature, idx) => (
                        <Badge bg="secondary" className="me-2 mb-2" key={idx}>
                          ✓ {feature}
                        </Badge>
                      ))}
                    </div>
                    <Button as={Link} to="/products" variant="outline-primary" size="sm">
                      View Details →
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="text-center mt-4">
            <Button as={Link} to="/products" className="btn-primary-custom" size="lg">
              View All Products →
            </Button>
          </div>
        </Container>
      </section>

      {/* Services Overview */}
      <section className="section-padding company-profile-section">
        <Container>
          <div className="section-title">
            <h2>Our Services</h2>
            <p>Comprehensive thermal engineering solutions for your business</p>
          </div>
          <Row>
            {keyServices.map((service, index) => (
              <Col lg={3} md={6} className="mb-4" key={index}>
                <div className="service-card text-center h-100">
                  <div style={{ 
                    fontSize: '2.5rem',
                    marginBottom: '1.5rem',
                    color: '#64748b'
                  }}>
                    {service.icon}
                  </div>
                  <h4 style={{ fontWeight: '600', color: '#1e293b' }}>{service.title}</h4>
                  <p style={{ color: '#64748b' }}>{service.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
          <div className="text-center mt-4">
            <Button as={Link} to="/services" className="btn-primary-custom" size="lg">
              Explore All Services
            </Button>
          </div>
        </Container>
      </section>

      {/* Video Showcase */}
      <section className="section-padding">
        <Container>
          <div className="section-title">
            <h2>See Our Work in Action</h2>
            <p>Watch our manufacturing processes and product demonstrations</p>
          </div>
          <Row>
            <Col lg={8} className="mb-4">
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="ratio ratio-16x9">
                  <iframe
                    src="https://www.youtube.com/embed/PW4KSKwV6B4?rel=0&modestbranding=1"
                    title="Allied Thermal Main Demo"
                    allowFullScreen
                    style={{ borderRadius: '12px', border: 'none' }}
                  ></iframe>
                </div>
                <div className="text-center mt-3">
                  <h5 style={{ fontWeight: '700', color: '#1e293b' }}>
                    🎥 Allied Thermal Manufacturing Excellence
                  </h5>
                  <p className="text-muted">Complete overview of our thermal solutions</p>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className="bg-white p-4 rounded shadow-sm h-100">
                <h5 style={{ fontWeight: '700', color: '#1e293b', marginBottom: '1.5rem' }}>
                  🏭 Why Choose Allied Thermal?
                </h5>
                <div className="mb-3">
                  <strong>✓ Complete Manufacturing:</strong>
                  <p className="mb-2 text-muted">From design to delivery, we handle everything</p>
                </div>
                <div className="mb-3">
                  <strong>✓ Quality Assurance:</strong>
                  <p className="mb-2 text-muted">ISO certified processes and materials</p>
                </div>
                <div className="mb-3">
                  <strong>✓ Expert Support:</strong>
                  <p className="mb-2 text-muted">24/7 technical assistance and maintenance</p>
                </div>
                <div className="mb-3">
                  <strong>✓ Proven Track Record:</strong>
                  <p className="mb-2 text-muted">500+ successful projects delivered</p>
                </div>
                <Button as={Link} to="/company-profile" variant="outline-primary" className="w-100">
                  Learn More About Us
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Call to Action */}
      <section className="section-padding contact-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <h2 style={{ color: 'white', fontWeight: '700', fontSize: '2.2rem' }}>
                Ready to Start Your Thermal Project?
              </h2>
              <p style={{ fontSize: '1.1rem', opacity: 0.9, marginBottom: '2rem' }}>
                Get expert consultation and free quotes for your thermal engineering needs. 
                Our team is ready to help you achieve optimal efficiency and performance.
              </p>
              <div>
                <div className="mb-2">📞 <strong>Call:</strong> +91 9312068097</div>
                <div className="mb-2">💬 <strong>WhatsApp:</strong> Available 24/7</div>
                <div>✉️ <strong>Email:</strong> alliedthermaldlf@gmail.com</div>
              </div>
            </Col>
            <Col lg={4} className="text-center">
              <Button 
                as={Link} 
                to="/contact-us" 
                className="btn-primary-custom mb-3"
                size="lg"
                style={{ width: '100%' }}
              >
                Get Free Quote Now
              </Button>
              <Button 
                href="https://wa.me/919312068097?text=Hello! I'm interested in Allied Thermal services."
                target="_blank"
                size="lg"
                style={{
                  background: '#25d366',
                  color: 'white',
                  border: 'none',
                  width: '100%'
                }}
              >
                💬 WhatsApp Us
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
